import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Multi Location Settings'
      breadcrumbs={[
        {
          label: 'Sync Apps',
        },
        {
          label: 'Multi Location',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/sync-app/multi-location',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
